"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonRippleStyles = exports.getBtnSpacing = exports.getBtnAttributes = exports.getAttr = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _colors = require("../tokens/colors");
var _sizes = require("../tokens/sizes");
var _spacing = _interopRequireDefault(require("../tokens/spacing"));
var colors = _interopRequireWildcard(require("../tokens/color/PrimaryColors"));
var _teal = _interopRequireDefault(require("../tokens/color/teal"));
var _white = _interopRequireWildcard(require("../tokens/color/white"));
var _misc = _interopRequireDefault(require("../tokens/misc"));
var _get2 = _interopRequireDefault(require("lodash-es/get"));
var _commonHelper = require("../helpers/commonHelper");
var _Ripple = require("../Ripple");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var propsBtnColors = _objectSpread(_objectSpread({}, colors), {}, {
  teal: _teal["default"],
  white: _objectSpread({}, _white.whiteShades),
  coal: {
    z400: colors.black,
    z500: colors.black,
    z600: colors.grey.z900,
    z700: colors.grey.z900
  }
});
var appearances = {
  "default": {
    text: _colors.button["default"].text,
    icon: _colors.button["default"].icon,
    background: _colors.button["default"].background,
    border: _colors.button["default"].border,
    hoverBackground: _colors.button["default"].backgroundHover,
    hoverBorder: _colors.button["default"].borderHover,
    focusBackground: _colors.button["default"].backgroundFocus,
    focusBorder: _colors.button["default"].borderFocus,
    activeBackground: _colors.button["default"].backgroundActive,
    activeBorder: _colors.button["default"].borderActive
  },
  location: {
    text: _colors.button["default"].text,
    icon: _colors.button["default"].icon,
    background: _colors.button["default"].background,
    border: _colors.button["default"].border,
    hoverBackground: _colors.button["default"].backgroundHover,
    hoverBorder: _colors.button["default"].borderHover,
    focusBackground: _colors.button["default"].backgroundFocus,
    focusBorder: _colors.button["default"].borderFocus,
    activeBackground: _colors.button["default"].backgroundActive,
    activeBorder: _colors.button["default"].borderActive
  }
};
var buttonSizes = {
  large: {
    lineHeight: _sizes.button.large.height,
    minWidth: "35rem",
    padding: _spacing["default"].medium,
    fontSize: "1.8rem",
    iconSize: 14,
    activeShadow: "0 0.4rem 0.6rem"
  },
  "default": {
    lineHeight: _sizes.button["default"].height,
    minWidth: "15rem",
    padding: _spacing["default"].small,
    fontSize: "1.6rem",
    iconSize: 12,
    activeShadow: "0 0.4rem 0.6rem"
  },
  compressed: {
    lineHeight: _sizes.button.compressed.height,
    minWidth: "auto",
    padding: _spacing["default"].small,
    fontSize: "1.4rem",
    iconSize: 10,
    activeShadow: "0 0.3rem 0.6rem"
  },
  small: {
    lineHeight: _sizes.button.small.height,
    minWidth: "auto",
    padding: _spacing["default"].small,
    fontSize: "1.4rem",
    iconSize: 10,
    activeShadow: "0 0.3rem 0.6rem"
  },
  largeIcon: {
    lineHeight: _sizes.button.large.height,
    minWidth: "auto",
    padding: _spacing["default"].medium,
    fontSize: "1.6rem",
    iconSize: 20,
    activeShadow: "none"
  }
};
var isLinkButton = function isLinkButton(props) {
  return props.appearance === _misc["default"].button.appearances.link;
};
var isOutlineButton = function isOutlineButton(props) {
  return props.appearance === _misc["default"].button.appearances.outline;
};
var getBtnSpacing = exports.getBtnSpacing = function getBtnSpacing(props) {
  return props.text ? isLinkButton(props) ? _spacing["default"].xxsmall : _spacing["default"].xsmall : 0;
};
var isLocateMeButton = function isLocateMeButton(props) {
  return props.appearance === _misc["default"].button.appearances.locateMe;
};
var getBtnAttributes = exports.getBtnAttributes = function getBtnAttributes(props) {
  var isOutline = isOutlineButton(props);
  var isLink = isLinkButton(props);
  var isLocateMe = isLocateMeButton(props);
  var disabledColor = propsBtnColors[_misc["default"].button.disabledColor];
  var activeColor = (0, _get2["default"])(propsBtnColors, "".concat(props.btnColor), disabledColor);
  var propsBtnColor = props.disabled ? disabledColor : activeColor;

  // Get the styles for the button's selected appearance.
  var appearanceStyles = appearances["default"];

  // Get the styles for the button's selected size.
  var sizeStyles = isLink ? buttonSizes.compressed : buttonSizes[props.size] || buttonSizes["default"];

  // Merge the two style hashes together to create the base styles.
  var styles = _objectSpread(_objectSpread({}, appearanceStyles), sizeStyles);
  styles.borderWidth = "0.1rem";
  //define button colors for  button according to outline
  if (isOutline) {
    //outline button with propsBtnColor
    styles.background = "transparent";
    styles.text = propsBtnColor.z500;
    styles.hoverText = propsBtnColor.z700; // styles.background;
    styles.border = propsBtnColor.z400;
    styles.hoverBackground = (0, _commonHelper.getRGBAFromHex)(propsBtnColor.z500, 0.04);
    styles.hoverBorder = propsBtnColor.z600;
    styles.focusBorder = propsBtnColor.z600;
    styles.activeBackground = (0, _commonHelper.getRGBAFromHex)(propsBtnColor.z500, 0.16);
    styles.activeBorder = propsBtnColor.z600;
    styles.customBoxShadow = "unset";
  } else if (isLink) {
    styles.border = "transparent";
    styles.background = "transparent";
    styles.text = propsBtnColor.z500;
    styles.hoverText = propsBtnColor.z600;
    styles.hoverBackground = "transparent";
    styles.focusBackground = "transparent";
    styles.activeBackground = "transparent";
    styles.customBoxShadow = "none";
    styles.borderWidth = 0;
  } else if (isLocateMe) {
    styles.border = "transparent";
    styles.background = "transparent";
    styles.text = propsBtnColors.black;
    styles.hoverText = propsBtnColors.black;
    styles.hoverBackground = "transparent";
    styles.focusBackground = "transparent";
    styles.activeBackground = "transparent";
    styles.customBoxShadow = "none";
    styles.borderWidth = 0;
  } else if (props.btnColor === "chalk") {
    styles.border = "transparent";
    styles.background = colors.grey.z50;
    styles.text = propsBtnColors.black;
    styles.hoverText = propsBtnColors.black;
    styles.hoverBackground = colors.grey.z100;
    styles.focusBackground = colors.grey.z100;
    styles.activeBackground = colors.grey.z100;
    styles.customBoxShadow = "".concat(styles.activeShadow, " rgba(0,0,0,.08)");
    styles.borderWidth = 0;
  } else {
    var shadow = "rgba(0,0,0,0.5)";
    styles.background = propsBtnColor.z500;
    styles.border = propsBtnColor.z500;
    styles.hoverBackground = propsBtnColor.z600; //hoverColor;
    styles.focusBackground = shadow;
    styles.activeBackground = propsBtnColor.z600;
    styles.customBoxShadow = "".concat(styles.activeShadow, " rgba(0,0,0,.16)"); //"inset 0 0 0.8rem " + shadow;
    styles.borderWidth = 0;
  }

  // If the loading state is set, override some of the styles.
  if (!props.disabled && props.loading) {
    styles.hoverText = isOutline ? styles.text : styles.hoverText;
  }

  // If the button contains only an icon and no text, override some of the styles.
  if (props.icon && !props.text) {
    styles.minWidth = "3.6rem";
  }
  if (props.fontSize) {
    styles.fontSize = props.fontSize;
    styles.iconSize = parseFloat(props.fontSize) !== parseInt(props.fontSize) ? parseFloat(props.fontSize) * 10 : parseFloat(props.fontSize);
  }
  return styles;
};
var getAttr = exports.getAttr = function getAttr(key) {
  return function (props) {
    return getBtnAttributes(props)[key];
  };
};
var getButtonRippleStyles = exports.getButtonRippleStyles = function getButtonRippleStyles(_ref) {
  var preventRipple = _ref.preventRipple,
    appearance = _ref.appearance,
    btnColor = _ref.btnColor;
  if (preventRipple) {
    return "";
  }
  var outlineRippleColor = (0, _get2["default"])(propsBtnColors, "".concat(btnColor, ".z500"), "");
  var appearances = _misc["default"].button.appearances;
  var ripplesByAppearance = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, appearances.link, _Ripple.ripples.dark), appearances.locateMe, _Ripple.ripples.dark), appearances.outline, outlineRippleColor ? (0, _Ripple.getRippleStyles)(outlineRippleColor) : _Ripple.ripples.dark), appearances.solid, _Ripple.ripples.light);
  return ripplesByAppearance[appearance] || "";
};